import React from "react"

class HolidayCountrySelect extends React.Component {
	
  constructor(props) {
    super(props);

    this.processCountry = this.processCountry.bind(this);
  }

  componentDidMount () {
    var self = this;

    if (this.refs.countries) {
      $(this.refs.countries).select2({
        ajax: {
          url: '/admin/holidays/countries_remote',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              page: params.page,
              results_per_page: 100,
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;

            return {
              results: data.items,
              pagination: {
                more: (params.page * 100) < data.total_count
              }
            };
          },
          cache: true
        },
        allowClear: false,
        escapeMarkup: function (markup) {
          return markup;
        },
        placeholder: I18n.t('select_ellipsis'),
        templateResult: function (country) {
          return self.processCountry(country);
        },
        templateSelection: function (country) {
          if (!country.loading && country.name && typeof self.props.onChange == 'function') {
            self.props.onChange(country);
          }
          return self.processCountry(country);
        }
      }).on('select2:unselect', function () {
        if (typeof self.props.onChange == 'function') {
          self.props.onChange(null);
        }
      });
    }
  }

  render() {
    return (
      <div className='holiday_region'>
        <select className="form-control" ref="countries" style={{width: '100%', minHeight: 33}}>
          {this.props.country ? <option value={this.props.country.id}>{this.processCountry(this.props.country)}</option> : null}
        </select>
        {this.renderFieldError()}
      </div>
    );
  }

  renderFieldError() {
    if (this.props.hasError && this.props.hasError.includes('has-errors')) {
      if ($('.holiday_region').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0] && !$('.holiday_region').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className.includes('has-errors')) {
        $('.holiday_region').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className += this.props.hasError
      }
    }
    if (!this.props.hasError.includes('has-errors')) {
      if ($('.holiday_region').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0] && $('.holiday_region').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className.includes('has-errors')) {
        var select = $('.holiday_region').find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0]
        select.className = select.className.replace(/has-errors/g, "")
      }
    }
  };

  processCountry(country) {
    if (!country.loading && country.name) {
      return country.name;
    } else {
      return country.text;
    }
  }

}

export default HolidayCountrySelect